<template>
  <div class="checkInfo">
    <div class="detail">
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="width1 fontBold">物件番号</div>
          <div>{{bupinDetail.wujian_id}}</div>
        </div>
        <div class="detailDiv">
          <div class="width1 fontBold">物件名</div>
          <div>{{bupinDetail.wujian_name}}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="width1 fontBold">部品番号</div>
          <div>{{bupinDetail.bupin_no}}</div>
        </div>
        <div class="detailDiv">
          <div class="width1 fontBold">部品名</div>
          <div>{{bupinDetail.bupin_name}}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="width1 fontBold">订单号</div>
          <div>{{bupinDetail.purchase_no}}</div>
        </div>
        <div class="detailDiv">
          <div class="width1 fontBold">入库日期</div>
          <div>{{bupinDetail.in_date}}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="width1 fontBold">入库数量</div>
          <div>{{bupinDetail.in_count}}</div>
        </div>
        <div class="detailDiv">
          <div class="width1 fontBold">楼层</div>
          <div>{{bupinDetail.floor}}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="detailDiv">
          <div class="width1 fontBold">表面处理</div>
          <div>{{bupinDetail.surface_deal}}</div>
        </div>
        <div class="detailDiv">
          <div class="width1 fontBold">材质</div>
          <div>{{bupinDetail.caizhi}}</div>
        </div>
      </div>
      <div class="nowrapDiv">
        <div class="width3 fontBold">使用器具</div>
        <div>{{bupinDetail.check_tool}}</div>
      </div>
    </div>
    <div class="detail">
      <div style="display: flex;justify-content: center;">
        <el-image class="imageStyle1" :src="bupinCheckPointsRecord[0].url" fit="fill" :preview-src-list="[bupinCheckPointsRecord[0].url]"></el-image>
      </div>
      <div v-show="bupinCheckPointsRecord.length !== 0">
        <div class="nowrapDiv">
          <div class="fontBold">寸法检查</div>
        </div>
        <div class="nowrapDiv" v-for="bupinPoint in bupinCheckPointsRecord" v-bind:key="bupinPoint.id">
          <div class="detailDiv">
            <div class="fontBold">检查项目{{bupinPoint.point_mark}}实测值：</div>
            <div v-if="bupinPoint.result === 'false'" style="color: red">{{bupinPoint.measured_value}}</div>
            <div v-else>{{bupinPoint.measured_value}}</div>
          </div>
          <div class="detailDiv">
            <div class="fontBold">{{bupinPoint.point_mark}}标准值：</div>
            <div>{{ getStandardValueString(bupinPoint) }}</div>
          </div>
        </div>
      </div>
      <div v-show="bupinCheckItems.length !== 0" style="margin-top: 10px">
        <div class="nowrapDiv">
          <div class="fontBold">检查项</div>
        </div>
        <div class="detailDiv" v-for="bupinCheckItem in bupinCheckItems" v-bind:key="bupinCheckItem.id">
          <div class="fontBold">{{ bupinCheckItem.check_item_name }}：</div>
          <div>{{bupinCheckItem.resultText}}</div>
        </div>
      </div>
      <div v-show="bupinCheckBujian.length !== 0" style="margin-top: 10px">
        <div class="nowrapDiv">
          <div class="fontBold">组装检查</div>
        </div>
        <div class="detailDiv" v-for="bupinBujian in bupinCheckBujian" v-bind:key="bupinBujian.id">
          <div class="fontBold">检查项目{{bupinBujian.point_mark}}({{ bupinBujian.bujian_name }})：</div>
          <div>{{bupinBujian.resultText}}</div>
        </div>
      </div>
      <div class="nowrapDiv" style="margin-top: 10px">
        <div class="fontBold">外观情况：</div>
        <div>{{bupinCheckDetail.waiguan_result}}</div>
      </div>
      <div v-show="!bupinCheckDetail.waiguan_status">
        <div class="nowrapDiv">
          <div class="fontBold">外观不良原因：</div>
          <div>{{bupinCheckDetail.waiguan_remark}}</div>
        </div>
        <div class="nowrapDiv">
          <div class="fontBold">外观不良图片：</div>
        </div>
        <el-image v-show="bupinCheckDetail.waiguan_ng_pics_ids.length !== 0" v-for="imageUrl in bupinCheckDetail.waiguan_ng_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill" :preview-src-list="bupinCheckDetail.waiguan_ng_pics_list"></el-image>
      </div>
      <el-image v-show="bupinCheckDetail.pictures_pics_ids.length !== 0" v-for="imageUrl in bupinCheckDetail.pictures_pics_list" :preview-src-list="bupinCheckDetail.pictures_pics_list" v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: "BusBupinCheckInfo",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      bupinDetail:{},
      bupinCheckDetail:{},
      bupinCheckPointsRecord:[],
      bupinCheckItems:[],
      bupinCheckBujian:[]
    }
  },
  methods:{
    getStandardValueString(bupinPoint){
      if(bupinPoint.type === 'symmetric'){
        return bupinPoint.standard_value + '+/-' + bupinPoint.error_range;
      }else if(bupinPoint.type === 'inSymmetric'){
        return bupinPoint.standard_value + '+' + bupinPoint.error_rangeplus + '/-' + bupinPoint.error_rangereduce;
      }else{
        if((bupinPoint.lower_value != null && bupinPoint.lower_value !== 0) && (bupinPoint.upper_value != null && bupinPoint.upper_value !== 0)) {
          if(bupinPoint.include_lower && bupinPoint.include_upper){
            return '('+bupinPoint.lower_value + '~' + bupinPoint.upper_value+')';
          }else if(!bupinPoint.include_lower && !bupinPoint.include_upper){
            return '['+bupinPoint.lower_value + '~' + bupinPoint.upper_value+']';
          }else if(!bupinPoint.include_lower && bupinPoint.include_upper){
            return '['+bupinPoint.lower_value + '~' + bupinPoint.upper_value+')';
          }else{
            return '('+bupinPoint.lower_value + '~' + bupinPoint.upper_value+']';
          }
        } else if(bupinPoint.lower_value != null && bupinPoint.lower_value !== 0) {
          return (bupinPoint.include_lower ? '>' : '>=') + bupinPoint.lower_value;
        } else if(bupinPoint.upper_value != null && bupinPoint.upper_value !== 0) {
          return (bupinPoint.include_upper ? '<' : '<=') + bupinPoint.upper_value;
        } else {
          return '标准值设置错误';
        }
      }
    },
    async getBupinDetail(){
      let {data: res} = await this.$axios.get('/api/bupin/detail?id=' + this.parentData.in_id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.bupinDetail = res.data
      }
    },
    async getBupinCheckDetail(){
      let {data: res} = await this.$axios.get('/api/bupin/check/detail?id=' + this.parentData.id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.bupinCheckDetail = res.data
      }
    },
    async getBupinCheckPointsRecord(){
      let {data: res} = await this.$axios.get('/api/bupin/check/points/record?checkId=' + this.parentData.id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.bupinCheckPointsRecord = res.data
      }
    },
    async getBupinCheckItems(){
      let {data: res} = await this.$axios.get('/api/bupin/check/items?checkId=' + this.parentData.id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.bupinCheckItems = res.data
      }
    },
    async getBupinCheckBujian(){
      let {data: res} = await this.$axios.get('/api/bupin/check/bujian?checkId=' + this.parentData.id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.bupinCheckBujian = res.data
      }
    }
  },
  created() {
    this.getBupinDetail()
    this.getBupinCheckDetail()
    this.getBupinCheckPointsRecord()
    this.getBupinCheckItems()
    this.getBupinCheckBujian()
  }
}
</script>

<style scoped>
.checkInfo{
  background-color: #F4F8FD;
}
.detail{
  background-color: #FFFFFF;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
}
.detailDiv{
  width: 50%;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fontBold{
  font-weight: bold;
}
.width1{
  width: 25%;
}
.width2{
  width: 39%;
}
.width3{
  width: 12.5%;
}
.width4{
  width: 30%;
}
.width5{
  width: 50%;
}
.nowrapDiv{
  display: flex;
  flex-wrap: nowrap;
}
.ngdiv{
  width: 50px;
  height: 25px;
  background-color: #F1F1F1;
  margin-right: 5px;
  margin-bottom: 5px;
}
.ngdiv1{
  font-size: 12px;
  width: 50px;
  height: 25px;
  background-color: #1A73E8;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-bottom: 5px;
}
.imageStyle{
  width: 87px;
  height: 87px;
  margin-right: 5px
}
.imageStyle1{
  width: 500px;
  height: 500px;
  margin-right: 5px
}
</style>
